import { defineComponent, defineAsyncComponent, computed, ref, onBeforeUnmount, toRef } from 'vue'
import { BlockModule } from '../common'
import { useFaqContext } from '../faq/composables'
import { usePaginatedFaqAsync } from '@/datasources'
import { scrollToTopOfPage } from '@/lib/scrolling'

new BlockModule({
    selector: '.block-faq-search',
    vueComponent: defineComponent({
        name: 'block-faq-search',
        components: {
            FadeInOut: defineAsyncComponent(
                () => import('@/components/website/transition/FadeInOut.vue')
            ),
            MsigButton: defineAsyncComponent(
                () => import('@/components/website/button/button.vue')
            ),
            Pagination: defineAsyncComponent(
                () => import('@/components/website/pagination/Pagination.vue')
            ),
        },
        setup() {
            const { 
                isSearchPage,
                displaySearchTerm,
                inputSearchTerm,
                searchTerm,
                pageNumber,
                isBusySearching: isBusy
            } = useFaqContext()

            isSearchPage.value = true

            /** 
             * This component will be unmounted when user leaves Downloads Search page
             * So let's reset isSearchPage.value = false
            */
            onBeforeUnmount(() => {
                isSearchPage.value = false
            })

            const searchResults = usePaginatedFaqAsync(
                toRef(searchTerm),
                toRef(pageNumber),
                10,
                { evaluating: isBusy }
            )
            

            return {
                isBusy,
                searchResults,
                displaySearchTerm,
                pageNumber,
                scrollToTopOfPage
            }
        }
    })
})